// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { loadingToggler } from 'redux/modules/loading'
import { postNewPath } from 'helpers/api'
import { throwSubmissionError } from 'helpers/reduxFormFunctions'
import { UNCAUGHT_ERROR } from 'errors'
import { formatQuickAddDataForApi } from './helpers'

import {
  checkPathsWarningValidations,
  setPathValidationsMessagesInDrawer,
} from 'redux/modules/pathValidationsDrawer'

import {
  assignDefaultContactToSite,
  parseValidationMessages,
} from 'redux/helpers'

import {
  addPathToProjectSummary,
  handleChangeOpenPanel,
} from 'redux/modules/projectSummary'

const quickAddPath = pathData => (dispatch, getState) => (
  dispatch(loadingToggler(
    async () => {
      const { projectSummary } = getState()
      const defaultCompany = projectSummary.get('defaultCompany')
      const defaultContact = projectSummary.get('defaultContact')

      try {
        const formattedPathData = dispatch(formatQuickAddDataForApi(pathData))

        // if a site doesn't have a company in this payload,
        // assign whatever the project default is
        assignDefaultContactToSite(formattedPathData, defaultCompany, defaultContact)

        const { entity } = await postNewPath(formattedPathData)
        const { pathId } = entity
        await dispatch(addPathToProjectSummary(pathId))
        await dispatch(handleChangeOpenPanel())

        // we successfully created the new path but we need to see if it has warnings.
        // the Quick Add drawer is closed
        return dispatch(checkPathsWarningValidations([pathId]))
      } catch (err) {
        console.warn(err)

        // since we're handling a submit error for the quick add form,
        // we will never have any other pathId
        const pathId = 0
        const newPathValidations = {}

        if (err.json.errors) {
          const parsedValidationMessages = parseValidationMessages(err.json.errors)

          const validation = parsedValidationMessages[pathId]

          newPathValidations[pathId] = {
            errors: validation.messages,
            heading: validation.heading,
            warnings: [],
          }
        }

        dispatch(setPathValidationsMessagesInDrawer(
          err.message || UNCAUGHT_ERROR,
          newPathValidations
        ))

        // throws error to redux-form to fail submit
        throwSubmissionError(err)
      }
    })
  )
)

export default quickAddPath
